/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Field_PhoneInputs */

const tr_contact_form_field_phone = /** @type {(inputs: Contact_Form_Field_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (opsiyonel)`)
};

const en_contact_form_field_phone = /** @type {(inputs: Contact_Form_Field_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone (optional)`)
};

const de_contact_form_field_phone = /** @type {(inputs: Contact_Form_Field_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon (optional)`)
};

const ru_contact_form_field_phone = /** @type {(inputs: Contact_Form_Field_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Телефон (опционально)`)
};

/**
* | output |
* | --- |
* | "Phone (optional)" |
*
* @param {Contact_Form_Field_PhoneInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_field_phone = /** @type {((inputs?: Contact_Form_Field_PhoneInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Field_PhoneInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_field_phone(inputs)
	if (locale === "de") return de_contact_form_field_phone(inputs)
	if (locale === "ru") return ru_contact_form_field_phone(inputs)
	return tr_contact_form_field_phone(inputs)
});